import { useState } from 'react';
import { resolveResourceAction } from '../resource-action';
import type { ResourceItemDto } from '@/lib/types/resources.types';

/**
 * Card activation for a resource item (folder detail page, member dashboard
 * MYN-254), driven by the same resolver that picks the card's label
 * so the two never disagree: an external link opens in a new tab, a
 * file-backed item opens the detail dialog in place.
 *
 * Returns the item the dialog should show (null when closed) and the handlers.
 */
export function useOpenResource() {
  const [dialogItem, setDialogItem] = useState<ResourceItemDto | null>(null);

  function openItem(item: ResourceItemDto): void {
    if (resolveResourceAction(item) === 'open_external' && item.externalUrl) {
      window.open(item.externalUrl, '_blank', 'noopener,noreferrer');
      return;
    }
    setDialogItem(item);
  }

  return { dialogItem, openItem, closeDialog: () => setDialogItem(null) };
}
